import { inject, provideEnvironmentInitializer } from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_CONFIG_DEFINITION } from '@softline/dynamic';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  SOFTLINE_DEFINITION_ARBEITSBERICHT_EDIT,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_INPUT,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_QUERY,
} from './arbeitsbericht.api';
import { SOFTLINE_CONFIG_ARBEITSBERICHT } from './arbeitsbericht.config';
import { SOFTLINE_PERMISSION_TIME_REPORT } from './arbeitsbericht.permissions';
import { arbeitsberichtRoutes } from './arbeitsbericht.routes';
import { provideArbeitsberichtGlobals } from './arbeitsbericht.globals';
import { default as editDefaultDefinition } from './definitions/edit.json';
import { default as inputDefaultDefinition } from './definitions/input.json';
import { default as listDefaultDefinition } from './definitions/list.json';
import { default as queryDefaultDefinition } from './definitions/query.json';

export function provideArbeitsberichtModule(config?: import('./arbeitsbericht.config').ArbeitsberichtConfig) {
  // TODO: pass customer-specific ArbeitsberichtConfig via ctx.config in module-globals.ts
  return [
    provideSoftAppsModule(
      {
        name: 'arbeitsbericht',
        title: '#TIME_REPORT.TITLE',
        icon: 'fa-regular fa-business-time',
        route: '/arbeitsbericht',
        color: 'bg-warning text-black',
        permission: SOFTLINE_PERMISSION_TIME_REPORT,
        group: getModuleGroupByName('Gewerbe'),
      },
      withSoftAppsModuleRoutes({ app: arbeitsberichtRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
    ...provideArbeitsberichtGlobals(config),
  ];
}

export const arbeitsberichtProviders = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'arbeitsbericht',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#TIME_REPORT.TITLE',
      icon: 'fa-regular fa-business-time',
      route: '/arbeitsbericht',
      color: 'bg-warning text-black',
      permission: SOFTLINE_PERMISSION_TIME_REPORT,
      group: getModuleGroupByName('Gewerbe'),
    });
  }),
  { provide: SOFTLINE_CONFIG_ARBEITSBERICHT, useValue: {} },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST,
      definition: listDefaultDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_ARBEITSBERICHT_INPUT,
      definition: inputDefaultDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_ARBEITSBERICHT_EDIT,
      definition: editDefaultDefinition,
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_DEFINITION,
    useValue: {
      name: SOFTLINE_DEFINITION_ARBEITSBERICHT_QUERY,
      definition: queryDefaultDefinition,
    },
    multi: true,
  },
];
